import { ApiClientError } from './api.js';

/**
 * Translation key for a membership-related API refusal, or null.
 *
 * The two codes mean genuinely different things and must never share copy:
 * CHANNEL_MEMBERSHIP_REQUIRED is "join the channel" — the user can fix it —
 * while MEMBERSHIP_CHECK_UNAVAILABLE is "we could not check", where telling
 * them to join something they may already have joined would be wrong.
 */
export function membershipErrorKey(error: unknown): string | null {
  if (!(error instanceof ApiClientError)) return null;
  if (error.code === 'CHANNEL_MEMBERSHIP_REQUIRED') return 'membership.required';
  if (error.code === 'MEMBERSHIP_CHECK_UNAVAILABLE') return 'membership.unavailable';
  return null;
}
